import React from 'react';
import { IconExit } from '@paretogroup/tess';
import { ColorConstants } from '@shared/constants';
import * as S from './tag.styles';
import { chooseColor } from './tag.utils';

interface TagProps {
  text: string;
  onClose: () => void;
  dataTestId: string;
  dataAutoTestId: string;
}

export const Tag = ({
    text, onClose, dataTestId, dataAutoTestId,
}: TagProps) => (
    <S.TagWrapper
        key={text}
        color={chooseColor(text)}
        data-testid={dataTestId}
    >
        <S.TagContent>
            <S.TagText>{text}</S.TagText>
            <S.ExitButton onClick={onClose} data-auto-testid={dataAutoTestId}>
                <IconExit
                    size={12}
                    primaryColor={ColorConstants.white}
                    secondaryColor="transparent"
                />
            </S.ExitButton>
        </S.TagContent>
    </S.TagWrapper>
);
